export default __webpack_public_path__ + "static/3-6356032e6a4a5944a51dd40e86750ea9.png";